module.exports = __webpack_public_path__ + "static/media/no-image-available.0a700505.png";